import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";

interface IntroProps {
  headline: string;
  keywords: string[];
  introIcon?: string;
  frame?: number;
  fps?: number;
}

export const Intro: React.FC<IntroProps> = ({
  headline,
  keywords,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const glowPulse = Math.sin((frame / fps) * Math.PI) * 5 + 15;

  return (
    <div
      className="glass-panel glow-border-cyan"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        boxShadow: `0 0 ${glowPulse}px rgba(0, 242, 254, 0.25), var(--glass-shadow)`,
      }}
    >
      {/* Dynamic Category/Topic Badge */}
      <div className="badge badge-cyan">
        {keywords?.[0] || "TECH TRENDING"}
      </div>

      {/* Sub-headline / Alert Hook */}
      <div
        style={{
          fontSize: "24px",
          color: "var(--accent-yellow)",
          fontFamily: "var(--font-title)",
          fontWeight: 700,
          letterSpacing: "4px",
          textTransform: "uppercase",
          marginBottom: "20px",
        }}
      >
        🚨 BREAKING REPORT
      </div>

      {/* High-Impact Headline */}
      <h1
        style={{
          fontFamily: "var(--font-title)",
          fontSize: "58px",
          fontWeight: 900,
          lineHeight: 1.15,
          color: "#ffffff",
          letterSpacing: "-1px",
          background:
            "linear-gradient(135deg, #ffffff 40%, var(--accent-cyan) 80%, #ffffff 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        {headline}
      </h1>

      {/* Mini Accent Line */}
      <div
        style={{
          width: "120px",
          height: "6px",
          background:
            "linear-gradient(90deg, var(--accent-cyan), var(--accent-purple))",
          borderRadius: "3px",
          marginTop: "35px",
          boxShadow: "0 0 10px rgba(0, 242, 254, 0.5)",
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
